import React from 'react';
import { ContentContainerType } from 'types/enums';
import { ContentContainer } from 'app/components/Core/ChakraContentContainer';
import { Button, Flex, Grid, GridItem, Skeleton } from '@chakra-ui/react';

export const TuneCoreVersionFormLoader = () => (
  <ContentContainer
    type={ContentContainerType.LIST}
    pb={24}
    data-testid="tunecore-version-details-loader"
  >
    <Flex position="absolute" top={-16} right={4} gap={4}>
      <Button variant="secondary" size="md" isDisabled>
        Go to Song
      </Button>
      <Button variant="secondary" size="md" isDisabled>
        Sync
      </Button>
    </Flex>
    <Grid
      templateColumns="repeat(4, 1fr)"
      columnGap={4}
      w="full"
      maxW="640px"
      mx="auto"
    >
      <GridItem colSpan={{ base: 4, md: 2 }} h="70px">
        <Skeleton w="full" h="48px" />
      </GridItem>
      <GridItem colSpan={{ base: 4, md: 2 }} h="70px">
        <Skeleton w="full" h="48px" />
      </GridItem>
      <GridItem colSpan={{ base: 4, md: 2 }} h="70px">
        <Skeleton w="full" h="48px" />
      </GridItem>
    </Grid>
  </ContentContainer>
);
